

import React, {useEffect} from 'react';
import 'date-fns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';




import {useState} from "react";

import {BrowserRouter, Route, Routes} from "react-router-dom";

import Box from "@mui/material/Box";

import Home2 from "./HomeMui";


import ContractSectionFilterGrid from "./ContractSectionFilter/ContractSectionFilterGrid";
import DataPointGrid from "./DataPoint/DataPointGrid";
import DataPointValueGrid from "./DataPointValue/DataPointValueGrid";
import DataPointXrefGrid from "./DataPointXref/DataPointXrefGrid";
import DataPointAttributeGrid from "./DataPointAttribute/DataPointAttributeGrid";
import ExchangeGrid from "./ExternalData/Exchange/ExchangeGrid";
import FinancialGrid from "./ExternalData/Financial/FinancialGrid";
import InterestGrid from "./ExternalData/Interest/InterestGrid";
import PlatformGrid from "./ExternalData/Platform/PlatformGrid";
import ProductGrid from "./ExternalData/Product/ProductGrid";
import SubscriberGrid from "./ExternalData/Subscriber/SubscriberGrid";
import UsageGrid from "./ExternalData/Usage/UsageGrid";
import LicenseGrid from "./ExternalData/License/LicenseGrid";


import ContractFrame from "./Contract/ContractFrame";
import WorkFrame from "./Work/WorkFrame";
import WorkDashboardFrame from "./WorkDashboard/WorkDashboardLayout";

import ContractGrid from "./Contract/ContractGrid";
import ProfileGrid from "./ExternalData/Profile/ProfileGrid";
import UsersGrid from "./Users/UsersGrid";
import ViewershipGrid from "./ExternalData/Viewership/ViewershipGrid";
import StakeholderListGrid from "./ExternalData/StakeholderList/StakeholderListGrid";
import BatchGrid from "./Batch/BatchGrid";
import Login from "./app/Login";
import {useSelector} from "react-redux";
import {jwtDecode} from "jwt-decode";
import './setupDayjs';

import { LicenseInfo } from '@mui/x-license-pro';
import DollarArrowRightIcon from "./ImagesAndIcons/AttachMoneyArrowRight";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import AppMenuBar from "./AppMenuBar/AppMenuBar";
import ActiveQueriesGrid from "./Admin/ActiveQueriesGrid";

LicenseInfo.setLicenseKey(
    '23afbe4f2c8b6fe854f5d98aedec9526T1JERVI6NDMzMjksRVhQSVJZPTE2ODM2OTI0NTQwMDAsS0VZVkVSU0lPTj0x',
);



function AppMui(props) {

    console.log('VITE_BACKEND_URL =', import.meta.env.VITE_BACKEND_URL);

    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const selectorUserName = useSelector((state) => state.userProfileSlc.value.userName);

    useEffect(() => {
        // Check if the JWT token exists in localStorage
        const token = localStorage.getItem('token');  // Or use sessionStorage if needed

        // If the token exists, you can optionally decode it to validate it
        if (token) {
            try {
                const decodedToken = jwtDecode(token);

                // Optionally, check if the token is expired (you may need to adjust this)
                const currentTime = Date.now() / 1000;
                if (decodedToken.exp > currentTime) {
                    setIsAuthenticated(true);  // Token is valid, user is authenticated
                } else {
                    localStorage.removeItem('token');  // Token is expired, remove it
                    setIsAuthenticated(false);  // Require login again
                }
            } catch (error) {
                console.error('Invalid token', error);
                localStorage.removeItem('token');  // Remove the invalid token
                setIsAuthenticated(false);
            }
        } else {
            setIsAuthenticated(false);  // No token, require login
        }
    }, [selectorUserName !== null]);  // Runs only once on component mount

    return(
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            {
                !isAuthenticated &&
            <Box>
                <Login/>
            </Box>}

                {isAuthenticated &&
            <BrowserRouter>
                <div>

                <AppMenuBar setIsAuthenticated={setIsAuthenticated}/>

                <Routes>
                    <Route path= "/" element={<Home2/>}/>
                    <Route path= "/Batch" element={<BatchGrid/>}/>
                    <Route path= "/ContractFrontend" element={<ContractGrid/>}/>
                    <Route path= "/ResidualsFrontend" element={<ContractFrame/>}/>
                    <Route path= "/ContractSectionFilterFrontend" element={<ContractSectionFilterGrid/>}/>
                    <Route path= "/DataPoints" element={<DataPointGrid/>}/>
                    <Route path= "/DataPointValues" element={<DataPointValueGrid/>}/>
                    <Route path= "/DataPointXrefs" element={<DataPointXrefGrid/>}/>
                    <Route path= "/DataPointAttributes" element={<DataPointAttributeGrid/>}/>
                    <Route path= "/ExternalData/StakeholderLists" element={<StakeholderListGrid/>}/>
                    <Route path= "/ExternalData/Exchange" element={<ExchangeGrid/>}/>
                    <Route path= "/ExternalData/Financials" element={<FinancialGrid/>}/>
                    <Route path= "/ExternalData/Interest" element={<InterestGrid/>}/>
                    <Route path= "/ExternalData/Licenses" element={<LicenseGrid/>}/>
                    <Route path= "/ExternalData/Platforms" element={<PlatformGrid/>}/>
                    <Route path= "/ExternalData/Products" element={<ProductGrid/>}/>
                    <Route path= "/ExternalData/Profiles" element={<ProfileGrid/>}/>
                    <Route path= "/ExternalData/Subscribers" element={<SubscriberGrid/>}/>
                    <Route path= "/ExternalData/Usage" element={<UsageGrid/>}/>
                    <Route path= "/ExternalData/Viewership" element={<ViewershipGrid/>}/>
                    <Route path= "/Participations" element={<ContractFrame/>}/>
                    <Route path= "/Royalties" element={<ContractFrame/>}/>
                    <Route path= "/Work" element={<WorkFrame/>}/>
                    <Route path="/WorkDashboard" element={<WorkDashboardFrame/>}/>
                    <Route path="/users" element={<UsersGrid/>}/>
                    <Route path="/admin" element={<ActiveQueriesGrid/>}/>

                </Routes>

                </div>
            </BrowserRouter>
        }
        </LocalizationProvider>


    );


}

export default AppMui